// Luhn algorithm to verify the ICCID number
const isICCValid = ((array) => {
  return (value: string) => {
    if (!value) return false
    let lengthValue = value.length
    if (lengthValue < 19) return false
    let toggleBool = true
    let sum = 0

    for (lengthValue -= 1; lengthValue >= 0; lengthValue -= 1) {
      sum += toggleBool ? parseInt(value[lengthValue], 10) : array[parseInt(value[lengthValue], 10)]
      toggleBool = !toggleBool
    }

    return sum % 10 === 0
  }
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9])

export default isICCValid
